import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
  textBox: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
}));

export const ExpandingTextField = (props) => {
  const { label, value, onValueChange, onEnter } = props;
  const classes = useStyles();

  const handleChange = (event) => {
    onValueChange(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key !== 'Enter') {
      return;
    }
    // Enter submits this form on keydown. That reloads the page before the
    // reason save finishes, so the covered flag snaps back to Y.
    event.preventDefault();
    event.stopPropagation();
    onEnter();
  };

  return (
    <form
      className={classes.textBox}
      noValidate
      autoComplete="off"
      onSubmit={(event) => event.preventDefault()}
    >
      <TextField
        id="not-covered-text"
        autoFocus
        label={label}
        multiline
        maxRows={4}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
    </form>
  );
};
